import { useI18n } from '@ecom/i18n';
import { Skeleton } from '@ecom/ui-kit';
import { type ReactElement } from 'react';

export function FormSkeleton({ fields = 5 }: { fields?: number }): ReactElement {
  const { t } = useI18n();
  return (
    <div
      className="flex flex-col gap-4"
      role="status"
      aria-label={t('merchant.common.loadingAria')}
    >
      {Array.from({ length: fields }, (_, i) => (
        <div key={i} className="flex flex-col gap-1.5">
          <Skeleton width="30%" height="0.75rem" />
          <Skeleton width="100%" height="2.25rem" />
        </div>
      ))}
    </div>
  );
}
